import { ArticuloReadingDtoProps } from "./DTOs/ArticuloReadingDto"
import { GetArticulosByContactoQueryDtoProps } from "./DTOs/GetArticulosByContactoQueryDto"
import { GetArticulosByFiltersQueryDtoProps } from "./DTOs/GetArticulosByFiltersQueryDto"

export const articuloByFiltersAdapter = (
  articulo: GetArticulosByFiltersQueryDtoProps
): GetArticulosByFiltersQueryDtoProps => ({
  id: articulo.id,
  categorias: articulo.categorias,
  concepto: articulo.concepto,
  esDeCompra: articulo.esDeCompra,
  numeroReferencia: articulo.numeroReferencia,
  precioVenta: articulo.precioVenta,
  thumbnailBase64: articulo.thumbnailBase64,
  thumbnailMediaType: articulo.thumbnailMediaType,
  tipoArticulo: articulo.tipoArticulo,
})

export const articuloContactoIdByFiltersAdapter = (
  articulo: GetArticulosByContactoQueryDtoProps
): GetArticulosByContactoQueryDtoProps => ({
  id: articulo.id,
  categorias: articulo.categorias,
  concepto: articulo.concepto,
  esDeCompra: articulo.esDeCompra,
  numeroReferencia: articulo.numeroReferencia,
  precioVenta: articulo.precioVenta,
  thumbnailBase64: articulo.thumbnailBase64,
  thumbnailMediaType: articulo.thumbnailMediaType,
  tipoArticulo: articulo.tipoArticulo,
})

export const articuloAdapter = (
  articulo: ArticuloReadingDtoProps
): ArticuloReadingDtoProps => ({
  id: articulo.id,
  camposPersonalizados: articulo.camposPersonalizados,
  catalogos: articulo.catalogos,
  categorias: articulo.categorias,
  concepto: articulo.concepto,
  esDeCompra: articulo.esDeCompra,
  ficheroId: articulo.ficheroId,
  numeroReferencia: articulo.numeroReferencia,
  precioVenta: articulo.precioVenta,
  thumbnailBase64: articulo.thumbnailBase64,
  thumbnailMediaType: articulo.thumbnailMediaType,
  tipoArticulo: articulo.tipoArticulo,
})
